import { render, staticRenderFns } from "./OldMutualTermsAndConditions.vue?vue&type=template&id=c1f2ce64"
import script from "./OldMutualTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./OldMutualTermsAndConditions.vue?vue&type=script&lang=js"
import style0 from "./OldMutualTermsAndConditions.vue?vue&type=style&index=0&id=c1f2ce64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports